import React, { useContext, useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import {
  FaUserCog,
  FaChalkboardTeacher,
  FaBook,
  FaUsers,
  FaSignOutAlt,
  FaChevronDown,
  FaClipboardCheck
} from "react-icons/fa";
import "./Dashboard.css";

const Dashboard = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isExamDropdownOpen, setIsExamDropdownOpen] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  // Auto-update time
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Handle logout
  const handleLogout = () => {
    logout(navigate);
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar Navigation */}
      <div className="dashboard-sidebar">
        <div className="dashboard-header">
          <h2 className="dashboard-welcome">Welcome, {user?.name}</h2>
          <p className="dashboard-datetime">{currentDateTime.toLocaleString()}</p>
          <div className="dashboard-divider" />
        </div>

        <div className="dashboard-links-container">
          <div className="dashboard-links">
            {/* Exam Generator Section */}
            {(user?.role === "manager" ||
              user?.role === "group_manager" ||
              user?.role === "staff") && (
              <div className="dropdown">
                <button
                  className="dropdown-btn"
                  onClick={() => setIsExamDropdownOpen(!isExamDropdownOpen)}
                >
                  <FaChevronDown /> Exams
                </button>
                <div
                  className={`dropdown-content ${
                    isExamDropdownOpen ? "show" : ""
                  }`}
                >
                  {(user?.role === "manager" ||
                    user?.role === "group_manager") && (
                    <NavLink
                      to="create-exams"
                      className={({ isActive }) =>
                        isActive
                          ? "dashboard-link dashboard-link-active"
                          : "dashboard-link"
                      }
                    >
                      <FaUserCog /> Create Exams
                    </NavLink>
                  )}

                  <NavLink
                    to="your-courses"
                    className={({ isActive }) =>
                      isActive
                        ? "dashboard-link dashboard-link-active"
                        : "dashboard-link"
                    }
                  >
                    <FaBook /> Your Courses
                  </NavLink>

                  {user?.role === "group_manager" && (
                    <NavLink
                      to="exams"
                      className={({ isActive }) =>
                        isActive
                          ? "dashboard-link dashboard-link-active"
                          : "dashboard-link"
                      }
                    >
                      <FaChalkboardTeacher /> Manage Exams
                    </NavLink>
                  )}

                  {(user?.role === "manager" ||
                    user?.role === "group_manager") && (
                    <>
                      <NavLink
                        to="employee-completed-exams"
                        className={({ isActive }) =>
                          isActive
                            ? "dashboard-link dashboard-link-active"
                            : "dashboard-link"
                        }
                      >
                        <FaClipboardCheck /> Completed Exams
                      </NavLink>

                      <NavLink
                        to="pending-exams"
                        className={({ isActive }) =>
                          isActive
                            ? "dashboard-link dashboard-link-active"
                            : "dashboard-link"
                        }
                      >
                        <FaClipboardCheck /> Employee Pending Exams to Start
                      </NavLink>
                    </>
                  )}

                  {user?.role === "group_manager" && (
                    <NavLink
                      to="issues"
                      className={({ isActive }) =>
                        isActive
                          ? "dashboard-link dashboard-link-active"
                          : "dashboard-link"
                      }
                    >
                      <FaClipboardCheck /> Reported Issues
                    </NavLink>
                  )}
                </div>
              </div>
            )}

            <div className="dashboard-divider" />

            {/* User Management Section */}
            {(user?.role === "manager" || user?.role === "group_manager") && (
              <NavLink
                to="users"
                className={({ isActive }) =>
                  isActive ? "dashboard-link dashboard-link-active" : "dashboard-link"
                }
              >
                <FaUsers /> Manage Users
              </NavLink>
            )}
          </div>
        </div>

        <div className="dashboard-divider" />

        {/* Logout Button */}
        <button onClick={handleLogout} className="dashboard-logout">
          <FaSignOutAlt /> Logout
        </button>
      </div>

      {/* Main Content */}
      <div className="dashboard-main">
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
